import React, { createContext, useState, ReactNode } from "react";
import { ElementState } from "@creatomate/preview";

interface TrimContextType {
  trimmingElement?: ElementState;
  setTrimmingElement: (element: ElementState | undefined) => void;
  isTrimmingStart: boolean;
  setIsTrimmingStart: (isDragging: boolean) => void;
}

interface TrimProviderProps {
  children: ReactNode;
}

// Create a new context for dragging state
export const TrimContext = createContext<TrimContextType>({
  trimmingElement: undefined,
  setTrimmingElement: () => {},
  isTrimmingStart: false,
  setIsTrimmingStart: () => {}
});

export const TrimProvider: React.FC<TrimProviderProps> = ({ children }) => {
  const [trimmingElement, setTrimmingElement] = useState<ElementState | undefined>();
  const [isTrimmingStart, setIsTrimmingStart] = useState(false);

  const value = { trimmingElement, setTrimmingElement, isTrimmingStart, setIsTrimmingStart };

  return (
    <TrimContext.Provider value={value}>
      {children}
    </TrimContext.Provider>
  );
};
